import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { BogIndicator } from 'src/domains/sportsbook/webview/components/bog/BogIdicator.style';
import { withConfig } from 'src/withConfig';

interface BogMessageWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const BogMessageWrapper = withConfig(theme => styled('div', { label: 'BogMessageWrapper' })<BogMessageWrapperPropsType>`
    background-color: ${theme.star.bogBanner.bgColor};
    color: ${theme.star.bogBanner.txtColor};
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.medium};
    line-height: 1.3334;
    margin-top: 8px;
    padding: 8px 8px 8px 40px;
    position: relative;
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
`);

export const BogMessageIndicator = withConfig(theme => styled(BogIndicator, { label: 'BogMessageIndicator' })`
    background-color: ${theme.star.bog.bgColorSecondary};
    color: ${theme.star.bog.txtColorSecondary};
    left: 8px;
    position: absolute;
    top: 8px;
`);
